import { render, staticRenderFns } from "./ShowCreateProject.vue?vue&type=template&id=6ddfad03&scoped=true&"
import script from "./ShowCreateProject.vue?vue&type=script&lang=js&"
export * from "./ShowCreateProject.vue?vue&type=script&lang=js&"
import style0 from "./ShowCreateProject.vue?vue&type=style&index=0&id=6ddfad03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddfad03",
  null
  
)

export default component.exports